<template>
    <footer>
        <div class="bottom">
            <div class="container">
                <div class="block left-block">
                    <p class="copyright">
                        {{$t('footer.bottom.company_copyright', { year: new Date().getFullYear() })}}
                      |
                        <router-link
                          class="item"
                          :to="{name: 'faqs'}"
                        >
                          {{$t('header.faqs')}}
                        </router-link>
                      |
                        <a
                            :href="termsUrl"
                            target="_blank"
                        >
                          {{$t('footer.items.legals.terms')}}
                        </a>
                      |
                        <a
                            :href="privacyUrl"
                            target="_blank"
                        >
                          {{$t('footer.items.legals.privacy')}}
                        </a>
                      |
                        <a
                            :href="'mailto:soporte@divasplay.com'"
                            target="_blank"
                        >
                          {{$t('footer.items.legals.complaints')}}
                        </a>
                    </p>
                </div>
                <div class="block right-block">
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
  import resources from './../resources';

  export default {
      computed: {
          privacyUrl(){
              let langCode = this.$i18n.locale;
              return `/legals/privacy/${langCode}.pdf`;
          },
          termsUrl(){
              let langCode = this.$i18n.locale;
              return `/legals/terms/${langCode}.pdf`;
          },
          complianceUrl(){
              let langCode = this.$i18n.locale;
              return `/legals/compliance/${langCode}.html`;
          },
          zedplanUrl(){
              let langCode = this.$i18n.locale;
              return `https://www.zedplan.com/${langCode}`;
          }
      },
  }
</script>

<style scoped lang="scss">
    @import '../styles/variables';

    footer{
        color: #ffffff;
    }

    .middle{
        display: flex;
        align-items: center;

        border-top: 2px solid $pallete_main_color;
        border-bottom: 2px solid $pallete_main_color;
        min-height: 450px;

        background-image: url('/img/footer.jpg');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left;


        @media(max-width: 1250px){
            background-image: none;
            min-height: 0;
        }

        .content{
            display: flex;
            flex:1;
            justify-content: flex-end;

            @media(min-width: 1920px){
                justify-content: center;
            }

            .limiter{
                display: flex;
                flex-basis: calc(100% - 500px);
                justify-content: space-evenly;
                flex-wrap: wrap;
                text-align: left;

                @media(max-width: 1250px){
                    flex-basis: 100%;
                }

                @media(max-width: 600px){
                    flex-direction: column;
                }

                @media(min-width: 1920px){
                    flex-basis: 1280px;
                }
            }

            .block{
                flex-grow: 0;
                padding: 2em;

                @media (max-width: 1250px) and (min-width: 900px){

                }

                @media(max-width: 768px) and (min-width: 600px){
                    flex-basis: 50%;
                }

                @media(max-width: 768px){
                    text-align: center;
                }

                .title{
                    text-transform: uppercase;
                    font-weight: bolder;
                    font-size: .9em;
                }
            }
        }
    }

    .bottom{
        .container{
            padding: 20px;
            text-align: left;
            display: flex;
            color: #a8a8a8;

            a{
              font-weight: bold;
              text-decoration: underline;
            }

            @media(max-width: 960px){
                flex-direction: column;
            }
        }

        .block{
            display: block;
            clear:both;
        }

        .left-block{
            display: flex;
            flex-direction: column;
            flex: 1;

            .copyright{
                flex: 1;

                @media(max-width: 960px){
                    text-align: center;
                }
            }
        }

        .right-block{
            flex: 0;
            align-items: center;
        }

        .developed-by{
            display: block;
            margin: auto;
            width: 200px;

            .zp-logo{
                height: 30px;
                display: block;
                margin: auto;
            }

            .title{
                font-size: .65em;
                margin: 0;
                text-align: center;
            }
        }
    }
</style>
